import {gql} from '@apollo/client'

export default gql`
mutation DeleteSurveyFromUser($userId: ID!, $surveyId: ID!) {
  deleteSurveyFromUser(userId: $userId, surveyId: $surveyId) {
    id
    surveys {
      title
    }
  }
}
`